import { __DEV__ } from 'config/app';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { applyMiddleware, combineReducers, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import reduxThunk from 'redux-thunk';

import UIDucks from './ducks/UI.duck';
import UIModalDuck from './ducks/ui/UIModal.duck';
import UserDucks from './ducks/User.duck';

//Stores
// const sagaMiddleware = createSagaMiddleware();
export const history = createBrowserHistory();
const serverInitialState = {};

const combineDucks = (...ducks) =>
	combineReducers(
		ducks.reduce((root, duck) => {
			return { ...root, [duck.duckName]: duck.reducer };
		}, {}),
	);

/**
 * Over here you have to register your DUCKS
 */
const rootReducer = combineDucks(
	UserDucks,
	UIDucks,
	UIModalDuck,
);

export const store = createStore(
	connectRouter(history)(rootReducer),
	serverInitialState,
	composeWithDevTools(applyMiddleware(routerMiddleware(history), reduxThunk)),
);



// WEBPACK FOOTER //
// ./src/stores/store.js